import { useLocales, FormatService } from '@sevenrooms/locales'
import { Link, Text, type TextProps } from '@sevenrooms/ui-kit/typography'
import { useVenue } from '../../hooks'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

interface CallVenueMessageProps extends TextProps {}

export function CallVenueMessage({ ...props }: CallVenueMessageProps) {
  const { formatMessage } = useLocales()
  const { phoneNumber, countryCode } = useVenue()

  return (
    <Text {...props}>
      {phoneNumber
        ? formatMessage(reservationWidgetMessages.resCancelPageCallVenueSubheader, {
            venue_phone: (
              <Link
                data-test="venue-phone-number"
                color="primaryFont"
                textDecoration="underline"
                to={`tel:${phoneNumber}`}
                isExternal
                target="_self"
                {...props}
              >
                {FormatService.formatPhoneNumber(phoneNumber, countryCode ?? 'us')}
              </Link>
            ),
          })
        : formatMessage(reservationWidgetMessages.resCancelPageCallVenueSubheaderNoPhone)}
    </Text>
  )
}
